// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const insightWidth = "92%";
export const insights = "Insights__insights__HpvLR";
export const insightsItem = "Insights__insightsItem__jwUNP";
export const previous = "Insights__previous__8RGd1";
export const dismissed = "Insights__dismissed__kt4rE";
export const fullWidth = "Insights__fullWidth__eAw5J";
export const prevAnimation = "Insights__prevAnimation__R5uA1";
export const dismissedAnimation = "Insights__dismissedAnimation__V+Vvm";